var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegendLifeBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H0v26L26 0Z",
    fill: "#2AA5D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.793 7.543-1.237-1.237a.59.59 0 0 0-.431-.181.632.632 0 0 0-.625.625c0 .161.058.308.181.431l.194.194h-2.25v-2.25l.194.194c.123.123.27.181.431.181a.632.632 0 0 0 .625-.625.59.59 0 0 0-.181-.431L8.452 3.202C8.338 3.087 8.228 3 8 3a.6.6 0 0 0-.457.207L6.306 4.444a.59.59 0 0 0-.181.431c0 .371.317.625.625.625a.592.592 0 0 0 .431-.181l.194-.194v2.25h-2.25l.194-.194A.592.592 0 0 0 5.5 6.75a.632.632 0 0 0-.625-.625.59.59 0 0 0-.431.181L3.207 7.543C3.104 7.646 3 7.773 3 8c0 .228.087.338.202.452l1.242 1.242a.59.59 0 0 0 .431.181.632.632 0 0 0 .625-.625.592.592 0 0 0-.181-.431l-.194-.194h2.25v2.25l-.194-.194a.592.592 0 0 0-.431-.181.632.632 0 0 0-.625.625c0 .166.06.31.181.431l1.237 1.237A.6.6 0 0 0 8 13c.228 0 .338-.087.452-.202l1.242-1.242a.59.59 0 0 0 .181-.431.632.632 0 0 0-.625-.625.592.592 0 0 0-.431.181l-.194.194v-2.25h2.25l-.194.194a.592.592 0 0 0-.181.431c0 .307.254.625.625.625a.59.59 0 0 0 .431-.181l1.242-1.242C12.913 8.338 13 8.228 13 8s-.104-.354-.207-.457Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendLifeBlue);
export default __webpack_public_path__ + "static/media/legend-life-blue.0137e866.svg";
export { ForwardRef as ReactComponent };